const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import("web-vitals").then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      const sendMetric = (metric) => {
        onPerfEntry(metric);
        try {
          if (window.posthog && !window.navigator.doNotTrack) {
            // Use $web_vitals as the event name and follow PostHog's format
            window.posthog.capture("$web_vitals", {
              $web_vital_metric: metric.name,
              $web_vital_value: metric.value,
              $web_vital_rating: metric.rating,
              $web_vital_id: metric.id,
              // Additional context that might be useful
              path: window.location.pathname,
              navigationEntry: metric.entries?.[0]?.name || null,
              deviceType: window.innerWidth < 768 ? "mobile" : "desktop",
            });
          }
        } catch (error) {
          // Silently handle PostHog errors
        }
      };

      getCLS(sendMetric);
      getFID(sendMetric);
      getFCP(sendMetric);
      getLCP(sendMetric);
      getTTFB(sendMetric);
    });
  }
};

export default reportWebVitals;
